<script>
  import { useLocation, navigate } from "svelte-navigator";

  import Polygon from '/components/Atoms/Polygon.svelte'
  import Logo from '/components/Atoms/Logo.svelte'
  import Link from '/Atoms/Link'
  import PageVisibility from '/Atoms/PageVisibility'
  import { isMenuActive, scrollY } from '/stores.js';
  import { styleVars, limitValue } from '/helper'

  export let zIndex, initial = true

  let bgImage

  const location = useLocation();
  const maxWidth = 240;
  const minWidth = 160;


  let  type = "start"
  let navigationTarget = "/"
  let almanac = false

  let real100vh = 0
  let logoWidth = 0

  function onAlmanacIndex(path) {
    return path === "/almanac" || path === "/almanac/list" || path === "/de/almanac" || path === "/de/almanac/list"
  }

  function onAlmanacItem(path) {
    return (path.indexOf("/almanac") === 0 || path.indexOf("/de/almanac") === 0 ) && !onAlmanacIndex(path)
  }

  $: {
    type = onAlmanacIndex($location.pathname) ? "high" 
        : $scrollY > 10 || $location.pathname !== "/" ? "blurred" : "start"
    if (onAlmanacItem($location.pathname) || $location.pathname.match(/\/livestream$/))  type = "gone"
    if ($isMenuActive) type = "menu"

    navigationTarget = onAlmanacIndex($location.pathname) ? "/" : "/almanac"

    almanac = onAlmanacIndex($location.pathname) || onAlmanacItem($location.pathname)

    bgImage = process.env.STILL_IMAGE_URL || "/assets/images/still.jpg"
    
    //width = (0.8 * 25 * screenWidth) // ... minus #{ 0.8 * 5/4 * $grid-gap-large }
    //left = screenWidth - ( 0.1 * 25 * screenWidth ) - width  // ...minus #{ $grid-gap-large }

  }

</script>

<svelte:window bind:innerHeight={real100vh} />

<div 
  class="logo_container {type}" 
  class:initial
  style={styleVars({
    zIndex, 
    logoWidth: logoWidth + "px",
    imageUrl: `url('${bgImage}')`,
    real100vh: real100vh + "px"
  })}
  bind:clientWidth={logoWidth} 
>

  <Polygon
    bgColor="mint" 
    n={7} 
    blur={type === "blurred" ? 25 : 8} 
    insideShape={false} 
    bgImage={almanac && bgImage}
    class="logo_poly">
  </Polygon>
  <div class="logo">
    <Link to={navigationTarget} title={ navigationTarget === "/" ? "Home" : "Almanac"}>
      <PageVisibility let:visible>
        <Logo paused={!visible} />
      </PageVisibility>
        <span class="text" class:menuActive={$isMenuActive}>
          { navigationTarget !== "/" ? "Almanac" : ""}
        </span>
    </Link>
  </div>
  
</div>

<style lang="scss">

  .logo {
    cursor: pointer;
  }
  .logo_container {
    position: fixed;
    right: calc( #{ 0.1*25 }vw + #{ $grid-gap-large } );
    //left: calc( 100vw - #{ 0.1*25 }vw - #{ $grid-gap-large } - var(--logoWidth)  ); //  use left to avoid jump when scrollbar dissapears (left-to-right settings)
    width: calc( #{ 0.8*25 }vw - #{ 0.8 * 5/4 * $grid-gap-large } ); // 0.8 of 1 of 4 columns (=> 5 column gaps)
    @include media-small {
      //right: calc( #{ 0.1*25 }vw + #{ $grid-gap-small } );
      right: calc( #{ 0.1*25 }vw + #{ $grid-gap-small } );
      width: calc( #{ 0.8*25 }vw - #{ 0.8 * 5/4 * $grid-gap-small } ); // 0.8 of 1 of 4 columns (=> 5 column gaps)
    }

    /*
    height: var(--logoWidth);
    border: solid 1px black;
    */

    /*
    background-size: cover;
    background-attachment: fixed;
    background-image: var(--imageUrl);
    */
    
    max-width: 240px;
    min-width: 160px;
    opacity: 1;
    z-index: var(--zIndex);
    transition: all cubic-bezier(0.37, 0, 0.63, 1) 2s;
    transition-delay: 0.7s;
  }

  .logo_container.start {
    top: calc( var(--real100vh) - 90px - var(--logoWidth) );
    transition-delay: 0s;
  }
  .logo_container.blurred {
    top: calc( var(--real100vh) - 20px  - var(--logoWidth) );
    transition-delay: 0s;
  }
  .logo_container.menu {
    top: calc( var(--real100vh) - 20px  - var(--logoWidth) );
    transition-delay: 0s;
  }

  .logo_container.high {
    transition-delay: 0s;

    top: 2vw;
    bottom: auto;
    @include media-xl {
      top: 20px;
      bottom: auto;
    }
    @include media-1col-only {
      top: calc( var(--real100vh) - 20px  - var(--logoWidth) );
    }
  }

  .logo_container.gone {
    transition-delay: 0s;
    transition-duration: 0.3s;
    opacity: 0;
    bottom: -200px;
    pointer-events: none;
  }

  .logo_container.initial {
    transition-delay: 0s;
    transition-duration: 0.3s;
    opacity: 0;
  }

  .logo_container :global(svg) {
    position: absolute;
    top: 0;
    left:0;
  }

  .text {
    opacity: 0;
    transition: opacity 0.2s;
    :hover &, &.menuActive {
      opacity: 1;
    }

    position: absolute;
    bottom: 1.5em;
    text-align: center;
    left:50%;
    color: $color-red;
    @include grotesk-stack; 
    display: block;
    //background: blue;
    transform: translateX(-50%);
    
    font-size: 1.3vw;
    @include media-small {
    }

    @media screen and (max-width: 700px) {
      font-size: 15px
    }

    @media screen and (max-width: 1300px) {
      font-size: 18px
    }
    
    
    max-width: 240px;
    min-width: 160px;

  }
</style>